/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Fable_Plan_Feat4Inputs */

const en_model_fable_plan_feat4 = /** @type {(inputs: Model_Fable_Plan_Feat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 PRDs & 120 agent messages/mo, priority support`)
};

const id_model_fable_plan_feat4 = /** @type {(inputs: Model_Fable_Plan_Feat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 PRD & 120 pesan agent/bln, dukungan prioritas`)
};

/**
* | output |
* | --- |
* | "15 PRDs & 120 agent messages/mo, priority support" |
*
* @param {Model_Fable_Plan_Feat4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_fable_plan_feat4 = /** @type {((inputs?: Model_Fable_Plan_Feat4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Fable_Plan_Feat4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_fable_plan_feat4(inputs)
	return en_model_fable_plan_feat4(inputs)
});